import api from '@pray/shared/utils/api';

/**
 * Get lead client statistics
 * Returns total, count with integrations, and distinct integration types count
 * — independent of pagination/filters. When artistId is provided the stats are
 * scoped to that artist's org; otherwise (Pray staff) they're the org-wide aggregate.
 */
export const getLeadClientStats = async ({ artistId = null } = {}) => {
  const url = `/web/studio/lead-clients/stats`;
  const params = {};
  if (artistId) params.artist_id = artistId;
  const response = await api.executeGetRequest(url, params);
  return response.data;
};
